<template>
  <div>

    <v-toolbar
      flat
    >
      <v-btn 
        class="mt-3"
        @click="openFiltersDialog(true)"
      >
        <v-icon>mdi-filter-plus</v-icon>
        Filtro
      </v-btn>
    
      <v-spacer></v-spacer>

      <slot name="actionBar"></slot>

    </v-toolbar>

    <v-row v-if="filters.length > 0" class="mt-1">
      <v-col cols="12">
        <span class="text-caption mx-3">Filtros Adicionados:</span>
        <v-btn
          text
          color="error"
          class="text-caption float-right float-sm-left"
          x-small
          @click="removeAllFilters(true)"
        >
          Remover todos os filtros
        </v-btn>

        <v-chip-group
          column
          class="mx-3 mt-6 mt-sm-0"
        >
          <v-chip
            v-for="filter in filters"
            :key="filterToString(filter)"
            close
            @click:close="removeFilter(filter, true)"
            @click="openFiltersDialog(false, filter)"
          >
            {{ filterToString(filter) }}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
      

    <v-dialog
      v-model="editDialog"
      v-bind="$attrs"
      :scrollable="true"
      persistent
      :fullscreen="$vuetify.breakpoint.smAndDown"
      width="80%"
    >
      <v-card>
        <v-card-title class="px-3 py-0 px-md-5 py-md-1">
          <span class="text-h6 text-lg-h5">Filtros</span>
          <v-spacer></v-spacer>
          <v-btn
            text
            icon
            title="Cancelar"
            class="my-2"
            @click="cancelAction"
          >
            <v-icon right>mdi-close-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text id="dialogBody" class="mt-5 px-3 px-sm-4 px-md-6">
          
          <v-row class="mx-0">
            <v-col cols="12">
              <v-btn 
                class="mt-3"
                @click="addEmptyFilter"
              >
                <v-icon>mdi-filter-plus</v-icon>
                Filtro
              </v-btn>

              <v-btn 
                class="mt-3 ml-3"
                @click="removeAllFilters"
              >
                <v-icon>mdi-filter-off</v-icon>
                Limpar <span class="d-none d-sm-flex ml-1">Filtros</span>
              </v-btn>
            </v-col>
          </v-row>

          <!-- <v-row v-for="filter in filters" class="rounded mx-0" style="border: 1px solid #b5b5b5;"  v-bind:key="filter.field + filter.operator + filter.type"> -->
          <v-row v-for="(filter, index) in filters" class="rounded mx-0" style="border: 1px solid #b5b5b5;"  v-bind:key="filter.field + filter.operator + index">
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                v-model="filter.field"
                label="Filtrar por"
                :items="serverFields"
                item-value="field"
                item-text="text"
                @input="setFilterType(filter)"
                :autofocus="selectedFilter == filter"
              >
                <template v-slot:prepend>
                  <v-icon
                    color="error"
                    @click="removeFilter(filter)"
                    v-text="'mdi-filter-remove'"
                  ></v-icon>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="2" class="pl-12 pl-sm-1" v-if="filter.field">
              <v-autocomplete
                v-model="filter.operator"
                label="Operador"
                :items="getOperatorsList(filter)"
                item-value="operator"
                item-text="name"
              />
            </v-col>

            <v-col cols="12" sm="10" md="6" class="pl-12 pl-md-1" v-if="filter.operator && filter.operator != 'empty'">
              <v-text-field
                v-if="filter.type == 'string' || filter.type == 'text' "
                v-model="filter.fieldValues[0]"
                label="Valor"
              />

              <MaskedTextField
                v-if="filter.type == 'decimal'"
                :inputData.sync="filter.fieldValues[0]"
                mask-type="currency"
                :class="filter.operator == 'between' ? 'd-inline-block' : ''"
                label="Valor"
              />
              <MaskedTextField
                v-if="filter.type == 'decimal' && filter.operator == 'between'"
                :inputData.sync="filter.fieldValues[1]"
                mask-type="currency"
                class="d-inline-block"
                label="Valor"
              />
              
              <MaskedTextField
                v-if="filter.type == 'integer'"
                :inputData.sync="filter.fieldValues[0]"
                mask-type="integer"
                :class="filter.operator == 'between' ? 'd-inline-block' : ''"
                label="Valor"
              />
              <MaskedTextField
                v-if="filter.type == 'integer' && filter.operator == 'between'"
                :inputData.sync="filter.fieldValues[1]"
                mask-type="integer"
                class="d-inline-block"
                label="Valor"
              />
              
              <DateField
                v-if="(filter.type == 'date' || filter.type == 'datetime') && filter.operator != 'between'"
                :inputData.sync="filter.fieldValues[0]"
                label="Valor"
                :hasTodayButton="true"
              />
              <DateRangeField
                v-if="(filter.type == 'date' || filter.type == 'datetime') && filter.operator == 'between'"
                :inputData.sync="filter.fieldValues"
                label="Valores"
                :hasTodayButton="true"
              />

              <!-- <DateTimeField
                v-if="filter.type == 'date' && filter.operator != 'between'"
                :inputData.sync="filter.fieldValues[0]"
                label="Valor"
                :hasTodayButton="true"
              />
              <DateRangeField
                v-if="filter.type == 'date' && filter.operator == 'between'"
                :inputData.sync="filter.fieldValues"
                label="Valores"
                :hasTodayButton="true"
              /> -->
              
              <v-autocomplete
                v-if="filter.type == 'list' || filter.type == 'enum' || filter.type == 'specialization' || filter.type == 'boolean'" 
                class="mt-2"
                v-model="filter.fieldValues"
                label="Valores"
                :items="getListValues(filter)"
                item-value="value"
                item-text="text"
                multiple
                chips
                dense
                deletable-chips
              />
            </v-col>
          </v-row>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-2 py-0 px-md-4 py-md-1">
          <v-btn class="my-2" @click="cancelAction">
            Cancelar
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn color="success" class="my-2" @click="confirmAction">
            Aplicar Filtros
            <v-icon right>mdi-filter</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import DateRangeField from "@shared_components/date_range_field.vue"

export default {
  data: function () {
    return {
      showFilterSelect: false,
      editDialog: false,
      filters: [],
      key: 0,
      selectedFilter: null
    }
  },
  props: {
    typeOperators: {
      type: Array,
      default: () => []
    },
    serverFields: {
      type: Array,
      default: () => []
    },
    initialFilters: {
      type: Array,
      default: () => []
    },
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    DateRangeField: DateRangeField
  },
  mounted(){ 
    // console.log("Base filter mounted", this.initialFilters);
    this.addFilters(this.initialFilters);
  },
  methods: {
    addEmptyFilter: function() {
      this.filters.push({ field: "", type: "", operator: "", fieldValues: [], key: this.key++})
    },
    addFilters: function(filters) {
      for (let i = 0; i < filters.length; i++) {
        this.addFilter(filters[i]);
      }
    },
    addFilter: function(filter) {
      filter.key = this.key++;
      this.filters.push(filter);
    },
    setFilterType: function(filter) {
      filter.operator = "";
      filter.type = "";
      filter.fieldValues = [];
      let fieldObject = this.serverFields.find(obj => obj.field == filter.field);
      // console.log("fieldObject", fieldObject, filter)
      filter.type = fieldObject.type;

      let operatorList = this.getOperatorsList(filter);
      if (operatorList.length == 1) {
        filter.operator = operatorList[0].operator;
      }
    },
    getOperatorsList: function(filter) {
      // let fieldObject = this.serverFields.find(obj => obj.value == field);
      // console.log("fieldObject", filter);
      let operatorObject = this.typeOperators.find(obj => obj.type == filter.type);
      // console.log("operatorObject", operatorObject, this.typeOperators)
      return operatorObject.operators;
    },
    getListValues: function(filter){
      let fieldObject = this.serverFields.find(obj => obj.field == filter.field);
      return fieldObject.listValues;
    },
    removeFilter: function(filter, emitFilter=false){
      // const index = this.filters.indexOf(filter.key)
      // if (index >= 0) this.filters.splice(index, 1)
      this.filters = _.reject(this.filters, function(element) { return element.key === filter.key; });
      if (emitFilter) {
        this.confirmAction();
      }
    },
    removeAllFilters: function(emitFilter=false) {
      this.filters = [];
      if (emitFilter) {
        this.confirmAction();
      }
    },
    cancelAction: function(){
      this.editDialog = false;
      this.removeInvalidFilter();
      this.$emit("filter-cancel-action");
    },
    confirmAction: function(){
      this.editDialog = false;
      console.log(this.filters);
      this.removeInvalidFilter();
      this.$emit("filter-confirm-action", this.filters);
    },
    removeInvalidFilter: function() {
      for(let i = this.filters.length - 1; i >= 0 ; i--) {
        // console.log("validate filter", this.filters[i], this.validateFilter(this.filters[i]));
        if (!this.validateFilter(this.filters[i])) {
          this.removeFilter(this.filters[i]);
        }
      }
    },
    validateFilter: function(filter) {
      if (filter && filter.field && filter.operator && filter.type && ((filter.fieldValues && filter.fieldValues.length > 0) || (filter.operator == 'empty') )) {
        return true;
      }
      return false;
    },
    filterToString: function(filter) {
      // filter = {field, operator, type, values}
      if (this.validateFilter(filter)) {
        let typeOperatorObject = this.typeOperators.find(obj => obj.type == filter.type);
        let operatorObject = typeOperatorObject.operators.find(obj => obj.operator == filter.operator);
        let fieldObject = this.serverFields.find(obj => obj.field == filter.field);


        let values = "";
        if (typeOperatorObject.type == "list" || typeOperatorObject.type == "enum" || typeOperatorObject.type == "specialization" || typeOperatorObject.type == "boolean") {
          for (var i = 0; i < filter.fieldValues.length; i++) {
            if (i > 0) {
            values = values + ", ";  
            }
            let auxObj = fieldObject.listValues.find(obj => obj.value == filter.fieldValues[i])
            if (auxObj) {
              values = values + auxObj.text;
            }            
          }
        } else if (typeOperatorObject.type == "date" || typeOperatorObject.type == "datetime") {
          values = filter.fieldValues.map(val => this.formatDate(val)).join(" - ");
        } else {
          values = filter.fieldValues.map(val => val + '').join(" - ");
        }
        let text = fieldObject.text + " " + operatorObject.name + (operatorObject.operator != "empty" ? ": " + values : "");
        return text;
      }
      return null;
    },
    openFiltersDialog: function(addEmptyFilter=false, selectedFilter=null) {
      this.editDialog = true;
      if (addEmptyFilter) {
        this.addEmptyFilter();
      }
      this.selectedFilter = selectedFilter;
    }
  }
}
</script>

<style scoped>
</style>
